import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, NAV } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#121212] text-[#F6F3EB] texture-grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="sm:col-span-2 lg:col-span-4">
            <div className="flex items-center gap-4">
              <img src="/logo.png" alt="Logo BM MECHANICS" className="h-16 w-16 object-contain bg-[#F6F3EB] p-1" />
              <div>
                <p className="font-display font-black uppercase text-2xl tracking-tight leading-none">BM Mechanics</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#8C7B5D] mt-1">Atelier indépendant — Prilly</p>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-[#9A968C] max-w-sm">
              Mécanique automobile, moto et scooter dans l'Ouest lausannois. Travail soigné, devis clair, sans surprise.
            </p>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#4A4D53] mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={SITE.phoneHref} data-testid="footer-call-link" className="flex items-center gap-3 text-[#F6F3EB] hover:text-[#8C7B5D] transition-colors">
                  <Phone className="h-4 w-4 shrink-0 text-[#8C7B5D]" /> {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={SITE.emailHref} data-testid="footer-email-link" className="flex items-start gap-3 text-[#F6F3EB] hover:text-[#8C7B5D] transition-colors">
                  <Mail className="h-4 w-4 shrink-0 text-[#8C7B5D] mt-0.5" /> <span className="min-w-0">{SITE.email}</span>
                </a>
              </li>
              <li>
                <a href={SITE.mapsHref} target="_blank" rel="noopener noreferrer" data-testid="footer-maps-link" className="flex items-start gap-3 text-[#F6F3EB] hover:text-[#8C7B5D] transition-colors">
                  <MapPin className="h-4 w-4 shrink-0 text-[#8C7B5D] mt-0.5" /> Route de Cossonay 60, 1008 Prilly
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#9A968C]">
                <Clock className="h-4 w-4 shrink-0 text-[#8C7B5D] mt-0.5" />
                <span>Lun – Ven · 08:00–12:00 / 13:30–18:00<br />Sam · 09:00–12:00</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#4A4D53] mb-5">Navigation</p>
            <ul className="space-y-3 text-sm">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} data-testid={`footer-link-${item.testid}`} className="text-[#9A968C] hover:text-[#F6F3EB] transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/devis" data-testid="footer-link-devis" className="text-[#9A968C] hover:text-[#F6F3EB] transition-colors">
                  Demande de devis
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#4A4D53] mb-5">Légal</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/mentions-legales" data-testid="footer-link-mentions" className="text-[#9A968C] hover:text-[#F6F3EB] transition-colors">Mentions légales</Link></li>
              <li><Link to="/confidentialite" data-testid="footer-link-confidentialite" className="text-[#9A968C] hover:text-[#F6F3EB] transition-colors">Confidentialité</Link></li>
              <li><Link to="/cookies" data-testid="footer-link-cookies" className="text-[#9A968C] hover:text-[#F6F3EB] transition-colors">Cookies</Link></li>
              <li><Link to="/admin" data-testid="footer-link-admin" className="text-[#4A4D53] hover:text-[#F6F3EB] transition-colors">Espace atelier</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#242529] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[11px] tracking-[0.12em] text-[#4A4D53]">
            © 2026 BM MECHANICS — Tous droits réservés — Prilly, Canton de Vaud, Suisse
          </p>
          <p className="font-mono text-[11px] tracking-[0.12em] text-[#4A4D53]">
            Mécanicien Prilly · Lausanne · Renens · Vaud
          </p>
        </div>
      </div>
    </footer>
  );
}
